import {StyleSheet} from "aphrodite";

import {View} from "@khanacademy/wonder-blocks-core";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {staticUrl} from "@khan/urls";

const KhanmigoActivitiesLabel = ({label}: {label: string}): JSX.Element => {
    return (
        <View
            style={[
                styles.flex,
                styles.negativeMargin,
                styles.hoverGray,
                styles.boldPurple,
            ]}
        >
            <View>{label}</View>
            <img
                height="30"
                alt=""
                src={staticUrl("/images/guide/purple-khanmigo-winking.png")}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    flex: {
        display: "flex",
        flexDirection: "row",
        alignItems: "end",
        gap: spacing.xxSmall_6,
    },
    hoverGray: {
        ":hover": {
            textDecoration: "none",
            color: color.offBlack64,
        },
    },
    negativeMargin: {
        marginTop: -10,
    },
    boldPurple: {
        fontWeight: "bold",
        color: color.eggplant,
    },
});

export default KhanmigoActivitiesLabel;
